import { Button, Popover, PopoverTrigger, SkeletonRect, Stack } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';

import { useGetOrderPaymentFai } from '../../api/useGetOrderPaymentFai';
import { FinancingDetails } from '../order-payment/FinancingSection';

import { FinancingStatusTag } from './shared/FinancingStatusTag';

interface FinancingCellProps {
	status?: string;
	purchasedVehicleId: string;
}

const PopoverContent = ({ purchasedVehicleId }: { purchasedVehicleId: string }) => {
	const { data: orderPaymentFai, isLoading } = useGetOrderPaymentFai(purchasedVehicleId);

	const financing = orderPaymentFai?.financing;
	const application = financing?.application;
	const lenderDecisions = financing?.lenderDecisions || [];

	return (
		<div style={{ width: 360 }}>
			<Stack itemsSpacing='8'>
				{isLoading ? (
					<SkeletonRect width='100%' height={120} />
				) : (
					<FinancingDetails application={application} lenderDecisions={lenderDecisions} />
				)}
			</Stack>
		</div>
	);
};

export const FinancingCell = ({ status, purchasedVehicleId }: FinancingCellProps) => {
	// If there is no status (NA), just show the tag without the dropdown
	if (!status) {
		return <FinancingStatusTag status={status} />;
	}

	// PopoverContent only renders when popover is open, so the hook will only be called then
	return (
		<PopoverTrigger>
			<Button
				className='financing-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<FinancingStatusTag status={status} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent purchasedVehicleId={purchasedVehicleId} />
			</Popover>
		</PopoverTrigger>
	);
};
